var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 280",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 80l60-30 60 30v60l-60 30-60-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 80l60 30M160 80l-60 30M100 110v60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 70l-12-3M30 70l-10 8M40 80l-18-2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 175l40-20 40 20v40l-40 20-40-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 175l40 20M230 175l-40 20M190 195v40"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxPattern);
export default __webpack_public_path__ + "static/media/box-pattern.68b1d026.svg";
export { ForwardRef as ReactComponent };